"use strict";
export default function(location, onDone) {
  return {
    filters: location.query.filters,
    onDone: onDone || location.query.onDone || "/app" + location.pathname
  };
}
